import TYPES from './types';

export const toggleAboutLayer = ({ open }) => {
  if(open) {
    return [
      { type: TYPES.toggleLayer, payload: 'about' },
    ]
  }

  return [
    { type: TYPES.toggleLayer, payload: null },
  ];
};
